import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { addToast } from '@heroui/toast';
import { fetchMySessions, revokeMySession, revokeOtherSessions } from '@/api/adminApi';
import { smallBtn } from '@/components/admin/shared';
import SessionsList from './SessionsList';

const QUERY_KEY = ['my-sessions'];

export default function ActiveSessionsSection() {
    const queryClient = useQueryClient();
    const [busyId, setBusyId] = useState<string | null>(null);
    const { data, isLoading } = useQuery({ queryKey: QUERY_KEY, queryFn: fetchMySessions, refetchInterval: 60_000 });
    const sessions = data ?? [];
    const onError = (error: any) => addToast({ title: 'Could not sign out', description: error?.response?.data?.message || error?.message || 'Please try again.', color: 'danger' });
    const onSuccess = (description: string) => () => { addToast({ title: description, color: 'success' }); queryClient.invalidateQueries({ queryKey: QUERY_KEY }); };
    const removeOne = useMutation({ mutationFn: revokeMySession, onMutate: setBusyId, onSuccess: onSuccess('Session signed out'), onError, onSettled: () => setBusyId(null) });
    const removeOthers = useMutation({ mutationFn: revokeOtherSessions, onSuccess: onSuccess('Signed out of other devices'), onError });

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between gap-3">
                <div>
                    <h3 className="text-base font-bold text-grey10 dark:text-white">Active sessions</h3>
                    <p className="text-sm text-grey40 dark:text-nightMuted">Devices currently signed in to your account.</p>
                </div>
                <button type="button" className={smallBtn} disabled={!sessions.some(s => !s.current) || removeOthers.isPending} onClick={() => window.confirm('Sign out every session except this one?') && removeOthers.mutate()}>Sign out others</button>
            </div>
            <SessionsList sessions={sessions} isLoading={isLoading} busyId={busyId} onRevoke={id => removeOne.mutate(id)} empty="No active sessions found." />
        </div>
    );
}
